import React from 'react';
import SearchBox from '../SearchBox/SearchBox';
import './Header.css';
import type { Table } from '../../types';
import { useI18n } from '../../i18n/I18nContext';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

export interface HeaderProps {
  scenarioName: string;
  tables: Table[];
  onSelectTable: (table: Table) => void;
  showToast: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void;
  headerRef: React.RefObject<HTMLDivElement>;
}

const Header: React.FC<HeaderProps> = ({
  scenarioName,
  tables,
  onSelectTable,
  showToast,
  headerRef,
}) => {
  const { t } = useI18n();

  return (
    <div className="header" ref={headerRef}>
      <div className="header-scenario-name">
        <span className="header-scenario-label">{t('header.scenario')}</span>{' '}
        <span className="header-scenario-value">{scenarioName || t('header.untitledScenario')}</span>
      </div>
      <div className="header-search">
        <SearchBox
          tables={tables}
          onSelectTable={onSelectTable}
          showToast={showToast}
        />
      </div>
      <LanguageSwitcher className="header-language-switcher" minWidth={144} />
    </div>
  );
};

export default Header;
